import Alpine from 'alpinejs';
import { initCookieConsent } from './components/cookie-consent';

import siteMenu from './components/site-menu';
import siteHeader from './components/site-header';
import heroVideo from './components/hero-video';
import reachPanel from './components/reach-panel';
import locationMap from './components/location-map';
import { initQrActions } from './components/qr-dialog';
import { initPanelBehaviors } from './components/panel-behaviors';

Alpine.data('siteMenu', siteMenu);
Alpine.data('siteHeader',siteHeader);
Alpine.data('heroVideo', heroVideo);
Alpine.data('reachPanel', reachPanel);
Alpine.data('locationMap', locationMap);

// Global
window.Alpine = Alpine;

// Inits
initCookieConsent();
Alpine.start();
const disposePanels = initPanelBehaviors();
const disposeQr = initQrActions();
if (import.meta.hot) import.meta.hot.dispose(() => {disposePanels();disposeQr();});
